import {DESTROY_TOKEN, SET_ACCESS_TOKEN} from "@/core/store/modules/auth/constants";
import api from "@/core/services/api/api.service"

export default {
    [SET_ACCESS_TOKEN](state, accessToken) {
        state.accessToken = accessToken;
     },
    [DESTROY_TOKEN](state) {
        api.removeAuthorizationHeader();
        state.accessToken = null;
     },
}
